export const ParticleConfig = {
    fpsLimit: 120,
    fullScreen: {
        enable: false,
        zIndex: -1,
    },
    interactivity: {
        events: {
            onClick: {
                enable: true,
                mode: "grab",
            },
            onHover: {
                enable: true,
                mode: "grab",
            },
            resize: true,
        },
        modes: {
            push: {
                quantity: 4,
            },
            repulse: {
                distance: 70,
                duration: 0.2,
            },
            grab: {
                distance: 220
            }
        },
    },
    particles: {
        color: {
            value: "#3a8bac",
        },
        links: {
            color: "#79B6BC",
            distance: 180,
            enable: true,
            opacity: 0.6,
            width: 1,
        },
        move: {
            direction: "none",
            enable: true,
            outModes: {
                default: "bounce",
            },
            random: false,
            speed: 2,
            straight: false,
        },
        number: {
            density: {
                enable: true,
                area: 700,
            },
            value: 90,
        },
        opacity: {
            value: 0.7,
        },
        shape: {
            type: "circle",
        },
        size: {
            value: { min: 1, max: 5 },
        },
    },
    detectRetina: true,
};